import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export const isSet = (v) => v && !String(v).includes("[À RENSEIGNER]") && String(v).trim() !== "";
export const telHref = (phone) => {
  if (!isSet(phone)) return undefined;
  let n = String(phone).replace(/[^+\d]/g, "");
  if (n.startsWith("0")) n = "+33" + n.slice(1);
  return `tel:${n}`;
};
export const mailHref = (email) => (isSet(email) ? `mailto:${email}` : undefined);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      setSettings({ phone: "[À RENSEIGNER]", email: "[À RENSEIGNER]", address: "[À RENSEIGNER]", hours: "[À RENSEIGNER]", social: {}, reviews_enabled: false, brands_enabled: false, brands: [], company: {} });
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || {}, loading: !settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}
